<script>
/**
 * Descripción: Pantalla ApplicationInstanceEditorViewComponent
 *
 * @displayName ApplicationInstanceEditorViewComponent
 */

import httpService from '@/services/httpService.js';
import BaseArrayHelper from '@/helpers/BaseArrayHelper.js';
import BaseLocalHelper from '@/helpers/BaseLocalHelper';

const OrganizationByInstanceFilterViewComponent = () =>
  import(
    '@/views/OrganizationByInstance/OrganizationByInstanceFilterViewComponent.vue'
  );

import { mapActions } from 'vuex';

export default {
  name: 'ApplicationInstanceEditorViewComponent',

  components: {
    OrganizationByInstanceFilterViewComponent
  },

  data() {
    return {
      applicationInstance: this.$_setApplicationInstanceObject(),
      loading: false,
      extraParams: {
        instanceId: this.$router.currentRoute.params.Id
      },
      textFieldProps: {
        'append-icon': 'mdi-calendar'
      },
      rule: [
        v => !!v || BaseLocalHelper.$_MsgFieldRequired('URL'),

        v =>
          // eslint-disable-next-line no-useless-escape
          /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/.test(
            v
          ) || BaseLocalHelper.$_MsgFieldAllowedValueInvalid('URL')
      ]
    };
  },

  computed: {
    /**
     * Configuracion customer
     */
    customerSetting() {
      return {
        input: {
          label: 'Cliente',
          itemText: 'customerName',
          validate: true
        },
        table: {
          columns: [
            {
              text: 'Cliente',
              align: 'start',
              value: 'customerName',
              show: true
            },
            {
              text: 'Activo',
              align: 'start',
              value: 'activo',
              show: true
            }
          ]
        },
        shared: {
          controller: 'Customer',
          key: 'customerId'
        }
      };
    },

    /**
     * Configuracion
     */
    cloudProviderSetting() {
      return {
        input: {
          label: 'Cloud Provider',
          itemText: 'cloudProviderName',
          validate: true
        },
        table: {
          columns: [
            {
              text: 'Cloud Provider',
              align: 'start',
              value: 'cloudProviderName',
              show: true
            },
            {
              text: 'Activo',
              align: 'start',
              value: 'activo',
              type: 'hidden',
              show: true
            }
          ]
        },
        shared: {
          controller: 'CloudProvider',
          key: 'cloudProviderId'
        }
      };
    },

    /**
     * Configuracion
     */
    serverSetting() {
      return {
        input: {
          label: 'Server',
          itemText: 'serverName',
          validate: true
        },
        table: {
          columns: [
            {
              text: 'Cloud Provider',
              align: 'start',
              value: 'cloudProviderName',
              show: true
            },
            {
              text: 'Server',
              align: 'start',
              value: 'serverName',
              show: true
            },
            {
              text: 'Database Server Ip Address',
              align: 'start',
              value: 'databaseServerIpAddress',
              show: true
            },
            {
              text: 'Application Server Ip Address',
              align: 'start',
              value: 'applicationServerIpAddress',
              show: false
            },
            {
              text: 'Domain Controller Ip Address',
              align: 'start',
              value: 'domainControllerIpAddress',
              show: false
            },
            {
              text: 'Server Features',
              align: 'start',
              value: 'serverFeatures',
              show: false
            }
          ]
        },
        shared: {
          controller: 'CloudServer',
          key: 'serverId'
        }
      };
    },

    /**
     * Configuracion
     */
    applicationSetting() {
      return {
        input: {
          label: 'Application',
          itemText: 'applicationName',
          validate: true
        },
        table: {
          columns: [
            {
              text: 'Application',
              align: 'start',
              value: 'applicationName',
              show: true
            },
            {
              text: 'Activo',
              align: 'start',
              value: 'activo',
              type: 'hidden',
              show: true
            }
          ]
        },
        shared: {
          controller: 'Application',
          key: 'applicationId'
        }
      };
    }
  },

  created() {
    this.addNavbar(['Instancias']);

    /**
     * Determinar si Es nuevo / editor
     */
    this.$_getObject();
  },

  methods: {
    ...mapActions('navbar', ['addNavbar']),

    /**
     * Determinar si Es nuevo / editor
     */
    $_getObject() {
      let data = this.$router.currentRoute.params.Id;
      if (data) {
        //HttpServices a la vista para obtener Vista
        this.applicationInstance.instanceId = data;
        this.loading = true;
        httpService
          .post('/ApplicationInstance/GetView', this.applicationInstance)
          .then(response => {
            this.loading = false;
            if (response != undefined) {
              // Encontro la entidad
              this.applicationInstance = BaseArrayHelper.SetObject(
                {},
                response.data
              );

              this.applicationInstance.installDate = new Date(
                this.applicationInstance.installDate.replace(/T/g, ' ')
              );
            } else {
              this.$_returnToFilter();
            }
          });
      }
    },

    /**
     * Obj de la pantalla
     */
    $_setApplicationInstanceObject() {
      return {
        instanceId: undefined,
        customerId: undefined,
        cloudProviderId: undefined,
        serverId: undefined,
        applicationId: undefined,
        instanceName: undefined,
        instanceUrl: undefined,
        activo: true,
        currentVersion: undefined,
        installDate: undefined
      };
    },

    /**
     * Volver al Filtro
     */
    $_returnToFilter() {
      this.$router.push({ name: 'ApplicationInstanceViewComponent' });
    },

    $_sendToApi() {
      this.loading = true;
      let object = BaseArrayHelper.SetObject({}, this.applicationInstance);
      httpService.post('ApplicationInstance/Save', object).then(response => {
        if (response != undefined) {
          //Logica JS luego de la acción exitosa!!!
          this.$router.push({ name: 'ApplicationInstanceViewComponent' });
        }
        this.loading = false;
      });
    }
  }
};
</script>

<template>
  <div>
    <!-- @ Use Loanding... -->
    <BaseSkeletonLoader v-if="loading" type="card-avatar, article, actions" />
    <div v-else>
      <h3>Gestionar Instancia</h3>
      <v-divider></v-divider>
      <v-flex xs12 sm12 md12>
        <!-- @BaseForm -->
        <!-- @BaseForm -->
        <BaseForm :method="$_sendToApi" :cancel="$_returnToFilter">
          <div slot="body">
            <v-row>
              <v-col cols="12" md="4">
                <!-- @BaseInputList -->
                <BaseInputList
                  :setting="customerSetting"
                  v-model="applicationInstance.customerId"
                />
              </v-col>
              <v-col cols="12" md="4">
                <!-- @BaseInputList -->
                <BaseInputList
                  :setting="cloudProviderSetting"
                  v-model="applicationInstance.cloudProviderId"
                />
              </v-col>
              <v-col cols="12" md="4">
                <!-- @BaseInputList -->
                <BaseInputList
                  :setting="serverSetting"
                  v-model="applicationInstance.serverId"
                />
              </v-col>
              <v-col cols="12" md="4">
                <!-- @BaseInputList -->
                <BaseInputList
                  :setting="applicationSetting"
                  v-model="applicationInstance.applicationId"
                />
              </v-col>
              <v-col cols="12" md="4">
                <!-- @BaseInputList -->
                <BaseInput
                  label="Nombre"
                  v-model="applicationInstance.instanceName"
                  :validate="['text']"
                  :max="100"
                />
              </v-col>
              <v-col cols="12" md="4">
                <!-- @BaseInputList -->
                <BaseInput
                  label="URL"
                  v-model="applicationInstance.instanceUrl"
                  :validate="rule"
                  :max="500"
                />
              </v-col>
              <v-col cols="12" md="4">
                <!-- @BaseInputList -->
                <BaseInput
                  label="Versión"
                  v-model="applicationInstance.currentVersion"
                  :validate="['text']"
                  :max="50"
                />
              </v-col>
              <v-col cols="12" md="4">
                <!-- @BaseDatePicker -->
                <BaseDatePicker
                  label="Fecha de Instalación"
                  type="date"
                  v-model="applicationInstance.installDate"
                  :textFieldProps="textFieldProps"
                  :validate="['text']"
                />
              </v-col>
              <v-col cols="12" md="4">
                <div
                  class="pa-2"
                  style=" display: flex;
                        align-items: center;
                        justify-content: center;"
                >
                  <BaseSwitch
                    v-model="applicationInstance.activo"
                    label="Estado"
                  />
                </div>
              </v-col>
            </v-row>
          </div>
          <!-- @slot Use this slot afterForm -->
          <div slot="afterForm" v-if="this.$router.currentRoute.params.Id">
            <h3>Organizaciones</h3>
            <v-divider></v-divider>
            <br />
            <OrganizationByInstanceFilterViewComponent
              :extraParams="extraParams"
            />
          </div>
        </BaseForm>
      </v-flex>
    </div>
  </div>
</template>
